import { CLEAR_ISSUE_STACK } from 'actions';

export function clearIssueStack() {
  return { type: CLEAR_ISSUE_STACK };
}
